export type BrokerNerdsBarkerCoreEnumsFulfillmentStatus = (typeof BrokerNerdsBarkerCoreEnumsFulfillmentStatus)[keyof typeof BrokerNerdsBarkerCoreEnumsFulfillmentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsFulfillmentStatus = {
  Unknown: 'Unknown',
  Pending: 'Pending',
  Complete: 'Complete',
  Canceled: 'Canceled',
} as const;
